import React from "react";

import { dictionaries } from "@/dictionaries/content";

import { type FileItem } from "../../map-panel-context";

import { SectionDocuments } from "./section-documents";
import { SectionTitle } from "./section-title";
import { SectionTitleNavLink } from "./section-title-nav-link";

interface DocumentsProps {
  files: FileItem[];
  goToDriveHref?: string;
}

export const Documents: React.FC<DocumentsProps> = ({
  files,
  goToDriveHref,
}) => {
  const trailing =
    goToDriveHref != null ? (
      <SectionTitleNavLink
        href={goToDriveHref}
        label={dictionaries.mapPage.schoolPanel.goToFiles}
      />
    ) : undefined;

  return (
    <div>
      <SectionTitle
        title="Files"
        trailing={trailing}
      />

      <SectionDocuments files={files} />
    </div>
  );
};
